"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImageQuestionModule = void 0;
const base_1 = require("./base");
const util_1 = require("./util");
class ImageQuestionModule extends base_1.SelectModule {
    constructor({ showLabels = true, ...rest }) {
        super(rest);
        this._type = "ImageQuestion";
        this.showLabels = showLabels;
    }
    validate() {
        return true;
    }
    toBuilderConfig() {
        if (this.validate()) {
            return {
                actionRequired: this.actionRequired,
                id: this.id,
                options: this.options.map((opt) => {
                    const option = {
                        id: opt.id || (0, util_1.generateUUID)(),
                        src: opt.src,
                    };
                    if (opt.label) {
                        option.label = opt.label;
                    }
                    return option;
                }),
                required: this.required,
                showLabels: this.showLabels,
                label: this.label,
                type: this.type,
                noBorder: this.noBorder,
            };
        }
        throw new Error((0, base_1.INVALID_MODULE)(this));
    }
    toSurveyConfig() {
        var _a;
        const { required, label, ...base } = this.toBuilderConfig();
        const surveyConfigModule = {
            ...base,
            options: this.options.map((opt) => {
                var _a, _b;
                return ({
                    id: opt.id || (0, util_1.generateUUID)(),
                    label: (_a = opt.label) === null || _a === void 0 ? void 0 : _a[this.languageCode],
                    src: (_b = opt.src) === null || _b === void 0 ? void 0 : _b[this.languageCode],
                });
            }),
            header: { children: (_a = label === null || label === void 0 ? void 0 : label[this.languageCode]) !== null && _a !== void 0 ? _a : "" },
        };
        if (required) {
            surveyConfigModule.validation = (0, util_1.addRequiredValidation)();
        }
        return surveyConfigModule;
    }
    editProps() {
        var _a;
        if (this.validate())
            return {
                id: this.id,
                options: this.options.map((opt) => {
                    var _a, _b;
                    return ({
                        id: opt.id || (0, util_1.generateUUID)(),
                        label: (_a = opt.label) === null || _a === void 0 ? void 0 : _a[this.languageCode],
                        src: (_b = opt.src) === null || _b === void 0 ? void 0 : _b[this.languageCode],
                    });
                }),
                type: this.type,
                question: (_a = this.label[this.languageCode]) !== null && _a !== void 0 ? _a : "",
                actionRequired: this.actionRequired,
            };
    }
}
exports.ImageQuestionModule = ImageQuestionModule;
//# sourceMappingURL=ImageQuestion.js.map